<!-- LanguageSelector.vue - jednostavnije -->
<template>
  <q-list separator>
    <q-item
      v-for="locale in localeOptions"
      :key="locale.value"
      clickable
      v-ripple
      :active="isActiveLocale(locale.value)"
      @click="emit('locale-changed', locale.value)"
    >
      <q-item-section>
        <q-item-label class="text-grey-8 text-weight-medium">
          {{ locale.label }}
        </q-item-label>
      </q-item-section>
      <q-item-section side v-if="isActiveLocale(locale.value)">
        <q-icon name="check" color="positive" />
      </q-item-section>
    </q-item>
  </q-list>
</template>

<script setup>
import { useLanguage } from '@/common/composables/useLanguage'

const emit = defineEmits(['locale-changed'])
const { currentLocale, localeOptions } = useLanguage()

const isActiveLocale = (localeValue) => {
  return currentLocale.value === localeValue
}
</script>

<style lang="scss" scoped>
    .text-grey-8 {
      body.body--dark & {
        color: white !important;
      }
    }
</style>